import React from "react";
import Portal from "../components/Portal";

const Upcoming = () => {
  return (
    <div className="clipping-container">
      <Portal category="top_rated" />
    </div>
  );
};
export default Upcoming;
